import type { captureException as sentryCaptureException } from '@sentry/react';

type CaptureContext = Parameters<typeof sentryCaptureException>[1];

interface IBufferedError {
  captureContext?: CaptureContext;
  error: unknown;
}

const errorBuffer: IBufferedError[] = [];
let isInitialized = false;

export const initSentry = () => {
  import('configs/sentry').then(() => {
    isInitialized = true;

    if (errorBuffer.length) {
      import('@sentry/react').then(({ captureException: capture }) => {
        errorBuffer.forEach(({ captureContext, error }) =>
          capture(error, captureContext),
        );
        errorBuffer.length = 0;
      });
    }
  });
};

export const captureException = (error: unknown, captureContext?: CaptureContext) => {
  if (isInitialized) {
    import('@sentry/react').then(({ captureException: capture }) =>
      capture(error, captureContext),
    );
  } else {
    errorBuffer.push({ captureContext, error });
  }
};
